import React, { useState } from 'react';
import { Box, Toast } from 'monday-ui-react-core';
import InvoiceList from './InvoiceList';
import InvoiceForm from './InvoiceForm';
import invoiceSyncService from '../../services/sync/invoiceSyncService';
import InvoiceDetails from './InvoiceDetails';

const InvoiceManagement = () => {
  const [view, setView] = useState('list');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (invoiceData) => {
    try {
      setLoading(true);
      if (view === 'edit' && selectedInvoice) {
        await invoiceSyncService.updateInvoice(selectedInvoice.id, invoiceData);
        Toast.show({
          message: 'Invoice updated successfully',
          type: Toast.types.SUCCESS
        });
      } else {
        await invoiceSyncService.createWaveInvoice(invoiceData);
        Toast.show({
          message: 'Invoice created successfully',
          type: Toast.types.SUCCESS
        });
      }
      setView('list');
      setSelectedInvoice(null);
    } catch (error) {
      console.error('Error submitting invoice:', error);
      Toast.show({
        message: 'Failed to save invoice',
        type: Toast.types.ERROR
      });
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    switch(view) {
      case 'list':
        return (
          <InvoiceList 
            onCreateNew={() => setView('create')}
            onSelectInvoice={(invoice) => {
              setSelectedInvoice(invoice);
              setView('details');
            }}
          />
        );
      case 'create':
      case 'edit':
        return (
          <InvoiceForm 
            invoice={selectedInvoice}
            onSubmit={handleSubmit}
            onCancel={() => {
              setView('list');
              setSelectedInvoice(null);
            }}
            isLoading={loading}
          />
        );
      case 'details':
        return (
          <InvoiceDetails 
            invoice={selectedInvoice}
            onEdit={() => setView('edit')}
            onBack={() => {
              setView('list');
              setSelectedInvoice(null);
            }}
          />
        );
      default:
        return <div>Invalid view</div>;
    }
  };

  return (
    <Box className="invoice-management">
      {renderContent()}
    </Box>
  );
};

export default InvoiceManagement; 